import { Skeleton, Grid, Typography, List, Box } from '@mui/material';

import AccountHistoryItemSkeleton from '@components/accountHistory/skeletons/AccountHistroyItemSkeleton';

const AccountHistoryBlockSkeleton = () => {
    return (
        <Grid item xs={12} sx={{ mt: 3, mb: 3 }}>
            <Typography
                variant="overline"
                data-testid="account-history-block-typography">
                <Skeleton sx={{ mb: 1.9 }} width={80} height={28} />
            </Typography>
            <Box
                component="span"
                sx={{
                    width: '100%',
                }}>
                <List>
                    <AccountHistoryItemSkeleton key="history-item-1" />
                </List>
            </Box>
        </Grid>
    );
};

export default AccountHistoryBlockSkeleton;
